import format from 'date-fns/format/index.js';
import { html } from 'fxjs/es';
import { UtilS } from '../../../Util/S/Function/module/UtilS.js';
import { messages } from '../../Setting/S/messages_id.js';
import { makeSellerStudioTable } from '../../Setting/S/table.ts';
import { getWithdrawLimitDate } from './util.ts';
import { StudioHeader } from '../../../../services/MarppleShop/marppleShopStudioApp/components/cells/Layout/StudioTitle.ts';

const formatDate = (s) => (s ? format(new Date(s), 'yyyy-MM-dd HH:mm') : '');

const makeWithdrawTableHtml = (withdraws, bank_account_type, holidays, is_tpl_possible) => {
  const is_mps = UtilS.isMarppleShopApp();
  const withdraw_amount_tooltip_content = html`
    <span class="lnr tooltip-icon tooltip-question"></span>
    <div class="tooltip-container">
      ${is_mps ? ET('mps2::studio::tooltip::withdraw_amount') : T(messages.tooltip.t6)}
    </div>
  `;

  return makeSellerStudioTable({
    col_rates: [
      ...[
        { rate: 10, align: 'center' }, // 신청일시
        { rate: is_tpl_possible ? 8 : 10 }, // POD
        { rate: is_tpl_possible ? 8 : 10 }, // 크리에이터배송 상품
      ],
      ...(is_tpl_possible ? [{ rate: 8 }] : []), // 입고
      ...[
        { rate: is_tpl_possible ? 8 : 10, align: 'center' }, // 디지털
        { rate: is_tpl_possible ? 8 : 10 }, // 멤버십/후원 정산
        { rate: is_tpl_possible ? 8 : 10 }, // 크리에이터 디자인 정산
        { rate: is_tpl_possible ? 8 : 10, tool_tip: withdraw_amount_tooltip_content },
        { rate: 8 },
        { rate: 8, align: 'center' },
        { rate: 8, align: 'center' },
        { rate: 8, align: 'center' },
        { rate: 8, align: 'center' },
      ],
    ],
    headers: [
      ...[
        T(messages.table.th30),
        is_mps
          ? ET('mps2::seller_studio::adjustment::amount', {
              product: ET('mps2::seller_studio::adjustment::marppleshop_product'),
            })
          : `${T(messages.menus.design_adjustments)} ${T(messages.table.th38)}`,
        is_mps
          ? ET('mps2::seller_studio::adjustment::amount', {
              product: ET('mps2::seller_studio::adjustment::creator_product'),
            })
          : `${T(messages.menus.seller_adjustments)} ${T(messages.table.th38)}`,
      ],
      ...(is_tpl_possible ? [`${T(messages.menus.tpl_adjustments)} ${T(messages.table.th38)}`] : []),
      ...[
        `${T(messages.menus.dtg_adjustments)} ${T(messages.table.th38)}`,
        `${T(messages.menus.membership_support_adjustment)} ${T(messages.table.th38)}`,
        `${ET('mps2::seller_studio::adjustment::amount', {
          product: ET('mps2::seller_studio::creator_design::enroll::title'),
        })}`,
        T(messages.table.th31),
        T(messages.table.th32),
        T(messages.table.th33),
        T(messages.table.th34),
        `${T(messages.table.th35)}(${T(messages.table.th36)})`,
        T(messages.table.th37),
      ],
    ],
    bodys: withdraws.map(
      ({
        amount,
        pod_amount,
        pb_amount,
        tpl_amount,
        dtg_amount,
        mcon_amount,
        membership_support_amount,
        reason,
        created_at,
        approved_at,
        canceled_at,
        real_amount,
      }) => {
        return [
          ...[formatDate(created_at), UtilS.commify(pod_amount || 0), UtilS.commify(pb_amount || 0)],
          ...(is_tpl_possible ? [UtilS.commify(tpl_amount || 0)] : []),
          ...[
            UtilS.commify(dtg_amount || 0),
            UtilS.commify(membership_support_amount || 0),
            UtilS.commify(mcon_amount),
            UtilS.commify(amount),
            approved_at ? UtilS.commify(real_amount) : '-',
            approved_at ? '-' : format(getWithdrawLimitDate(created_at, holidays), 'yyyy-MM-dd'),
            formatDate(approved_at) || '-',
            `${formatDate(canceled_at) || '-'} ${reason ? `(${reason})` : ''}`,
            approved_at
              ? T(messages.withdraws.finish)
              : canceled_at
                ? T(messages.withdraws.cancel)
                : T(messages.withdraws.pending),
          ],
        ];
      },
    ),
  });
};

export const makeWithdrawsSettingsBodyHtml = ({
  without_fee_amount,
  withdraws,
  bank_account_type,
  is_bank_account_filled,
  holidays,
  crew_withdraw_type,
  is_tpl_possible,
  // domain_name,
}) => {
  // const provide_amount = Math.floor(+withdraw_amount / 1.1);
  // const tax_amount = withdraw_amount - provide_amount;
  return html`
    <div class="header flex">
      <div class="left">
        ${new StudioHeader({
          title: UtilS.isMarppleShopApp() ? ET('mps2::studio::page::withdraws') : T(messages.menus.withdraws),
          description: UtilS.isMarppleShopApp()
            ? ET('mps2::studio::page::withdraws_guide')
            : T(messages.withdraws.p1),
          with_margin: false,
        }).toHtml()}
      </div>
      <div class="right">
        <div class="studio-withdraw">
          <div class="studio-withdraw__amount" data-show="${!!is_bank_account_filled}">
            ${T(messages.withdraws.p2)}<span
              class="studio-withdraw__available"
              data-without_fee_amount="${without_fee_amount}"
            >
              ${UtilS.commify(without_fee_amount)}원</span
            >
          </div>
          ${crew_withdraw_type === 'separate'
            ? `<button class="btn btn-blue request_withdraw">
            <img
              src="//s3.marpple.co/files/u_29089/2023/1/original/ed78b030f18cb8abfe21e1cb3831966c19b401ac1.webp"
              alt=""
            />
            ${T(messages.withdraws.btn1)}
          </button>`
            : ''}
        </div>
      </div>
    </div>
    <div
      class="bank_account"
      data-show="false"
      data-fx-json=${JSON.stringify({ bank_account_type, is_bank_account_filled })}
    ></div>
    <div class="body">
      <div id="withdraws" class="table-wrapper">
        ${makeWithdrawTableHtml(withdraws, bank_account_type, holidays, is_tpl_possible)}
      </div>
    </div>
  `;
};
